import React from 'react';
import PropTypes from 'prop-types';
import { useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { get, noop } from 'lodash';

import Dialog from '../../../components/Dialog';
import CopyImageForm from './CopyImageForm';
import { handleError } from '../../../utils/handleError';
import { handleSuccess } from '../../../utils/handleSuccess';
import { messages } from '../constants';
import { useCopyImage } from '../hooks';

const { msgCopy, msgCopied } = messages;

const CopyImageDialog = ({ selectedItem, isOpen, onClose }) => {
    const queryClient = useQueryClient();

    // mutations
    const mutateProps = {
        onError: (err) => toast.error(handleError(err)),
        onSettled: () => {
            queryClient.invalidateQueries('images');
        },
    };
    const { mutate: mutateCopyImage, isLoading } = useCopyImage({
        ...mutateProps,
        onSuccess: (res) => {
            onClose();
            toast.success(handleSuccess(res, msgCopied));
        },
    });

    // actions
    const handleCopyImage = async ({ newName }) => {
        await mutateCopyImage({
            image: get(selectedItem, 'image', ''),
            newName,
        });
    };

    const handleClose = () => {
        onClose();
    };

    return (
        <Dialog
            isSubmitting={isLoading}
            isOpen={isOpen}
            title={`${msgCopy} Image`}
            onClose={handleClose}
        >
            <CopyImageForm
                selectedItem={selectedItem}
                onClose={handleClose}
                onSubmit={handleCopyImage}
                isSubmitting={isLoading}
            />
        </Dialog>
    );
};

CopyImageDialog.propTypes = {
    selectedItem: PropTypes.object,
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
};

CopyImageDialog.defaultProps = {
    selectedItem: null,
    isOpen: false,
    onClose: noop,
};

export default CopyImageDialog;
